export var LINKS_FILTERS_KEY = 'links';

export var getDefaultLinksFilters = function() {
  return {
    title: '',
    categories: [],
  };
};

// Badge: only what differs from the defaults (search counts as one filter).
export var countActiveLinksFilters = function(filters) {
  var count = 0;
  if (filters.title) count += 1;
  if (filters.categories && filters.categories.length > 0) count += 1;
  return count;
};

export var filterLinks = function(links, filters) {
  var title = (filters.title || '').toLocaleLowerCase();
  var categories = filters.categories || [];
  return (links || []).filter(function(link) {
    var linkTitle = (link.title || '').toLocaleLowerCase();
    if (linkTitle.indexOf(title) === -1) return false;
    if (categories.length > 0 && categories.indexOf(link.link_category_id) === -1) return false;
    return true;
  });
};
